import { render, staticRenderFns } from "./ReporteOrigenRecurso.vue?vue&type=template&id=67c946ea&"
import script from "./ReporteOrigenRecurso.vue?vue&type=script&lang=js&"
export * from "./ReporteOrigenRecurso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports